<template>
  <PortalBlock :portal-block="5"></PortalBlock>
</template>

<script>
import PortalBlock from "./components/PortalBlock.vue";

export default {
  name: "portal-subscribe",
  components: {
    PortalBlock,
  },
};
</script>
